"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
exports.default = ApiException;
